import styled from "styled-components";
import { Colors, Metrics } from "configs";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 56px;
`;

export const TitleText = styled.h2`
  font-family: "Montserrat", "Nunito", sans-serif;
  color: #1f3b39;
  font-size: 2.1rem;
  font-weight: 800;
  margin: 0;

  span {
    color: ${Colors.primary};
  }
`;

export const TitleMark = styled.div`
  border-bottom: 3px solid #dca039;
  width: 70px;
  margin: 16px 0 22px 0;
`;

export const TextContainer = styled.p`
  max-width: 640px;
  font-size: 1.08rem;
  line-height: 1.6;
  color: ${Colors.secondary};
  margin: 0;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 28px;
  width: 100%;
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 10px 30px -12px rgba(0, 95, 90, 0.22);
  border: 1px solid #eef2f1;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  :hover {
    transform: translateY(-6px);
    box-shadow: 0 22px 44px -16px rgba(0, 95, 90, 0.35);
  }
`;

export const CardImage = styled.div`
  position: relative;
  height: 168px;
  background-image: ${({ image }) => `url(${image})`};
  background-size: cover;
  background-position: center;
  background-color: #b7e4e2;

  ::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 55%,
      rgba(0, 0, 0, 0.25) 100%
    );
  }
`;

export const Badge = styled.span`
  position: absolute;
  z-index: 2;
  top: 12px;
  left: 12px;
  font-size: 0.78rem;
  font-weight: 700;
  padding: 5px 12px;
  border-radius: 50px;
  background: #fff;
  color: ${({ variant }) =>
    variant === "error" ? Colors.error : Colors.primary};
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
`;

export const CardBody = styled.div`
  padding: 22px 22px 0 22px;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const CardTitle = styled.h3`
  font-weight: 800;
  font-size: 1.18rem;
  color: #1f3b39;
  margin: 0 0 10px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 2.6em;
`;

export const CardSummary = styled.p`
  font-size: 0.96rem;
  line-height: 1.5;
  color: ${Colors.secondary};
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const CardFooter = styled.div`
  margin-top: auto;
  padding: 18px 22px 22px 22px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
`;

export const PriceBlock = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.2;

  .price {
    font-weight: 800;
    font-size: 1.15rem;
    color: ${Colors.greenCheck};
  }

  .old-price {
    font-size: 0.82rem;
    color: ${Colors.secondary};
    text-decoration: line-through;
  }
`;

export const MoreButton = styled.button`
  background: ${Colors.primary};
  color: #fff;
  border: none;
  font-weight: 700;
  font-size: 0.92rem;
  padding: 9px 18px;
  border-radius: 50px;
  cursor: pointer;
  transition: 0.3s all;
  white-space: nowrap;

  :hover {
    background: #41c0ba;
  }
`;

export const EmptyState = styled.div`
  width: 100%;
  text-align: center;
  padding: 40px 0;
  color: ${Colors.secondary};
  font-size: ${Metrics.fontSize.xsm};
`;
